// extracted by mini-css-extract-plugin
export default {"wrapper":"PIYYyRTH","neonWrapper":"mcTvEB3A","button":"jsrjFvny"};